export class Clinic {
    constructor( 
        public ClinicID?: string,
        public ClinicName?: string,
        public Phone?: string,
        public ClinicWebsite?: string,
        public ClinicEmail?: string,
        public ClinicFax?: string,
        public ClinicLogo?: string,
        public LogoImage?: string,
		public bDeleteLogo?: boolean,
        public StreetAddress1?: string,
        public StreetAddress2?: string,
        public City?: string,
        public State?: string,
        public ZipCode?: string,
        public Country?: string,
        public Location?: Array<Location>,
        public bAdminClinic?: boolean,
		public UserCount?: string,
        public bDeleted?: boolean,
        public DeletedBy?: string,
        public DeletedOn?: Date,
    ) {}
}

export class Location {
    constructor( 
        public LocationID?: string,
        public ClinicID?: string,
        public LocationName?: string,
        public StreetAddress1?: string,
        public StreetAddress2?: string,
        public City?: string,
        public State?: string,
        public ZipCode?: string,
        public Country?: string,
        public Phone?: string,
        public Fax?: string,
        public bDefault?: boolean,
        public bDeleted?: boolean,
        public DeletedBy?: string,
        public DeletedOn?: Date,
    ) {}
}